import React from "react";
import { IconBasket1 } from "../../assets/icons";
import { isMobile } from "react-device-detect";
function AddToBasketRoundedButton({ onClick }) {
  const handleShowModal = () => {
    onClick(true);
  };
  return isMobile ? (
    <button
      className="btn-outline-success btn btn-sm small-svg  rounded-2 fs-07 text-white w-90"
      onClick={handleShowModal}
      style={{ background: "rgb(233 251 245)" }}
    >
      <IconBasket1 fillColor="#09a463cc" />

      <span className="ps-1">خرید بلیط</span>
    </button>
  ) : (
    <button
      className="btn-outline-success btn btn-sm small-svg  rounded-2 fs-085 text-white w-90"
      onClick={handleShowModal}
      style={{ background: "rgb(233 251 245)" }}
    >
      <IconBasket1 />

      <span className="ps-1">خرید بلیط</span>
    </button>
  );
}
export default AddToBasketRoundedButton;
